import { ConnectedPosition } from '@angular/cdk/overlay';
import { TypePopup } from 'src/app/_apps/app.constants';

export class PopupMenuConfig
{
    class: string;
    height: number;
    /**
     * vw unit
     */
    width: number;
    positions: ConnectedPosition[];
    typePopup: TypePopup = 'popover';
    isColored: boolean = false;
}
